import React, { useEffect, useCallback, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getFileCommandeRef, getDetailCommandeParRef, getCommandeByIdParRef, historiqueCommandeParRef } from "../../Redux/commandeReduce";
import ImprimerCmd from "./ImprimerCmd";
import Configuration from "../../configuration";
import jwt_decode from "jwt-decode";
import { t } from "react-multi-lang";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

function DetailsCmd({ obj,client }) {
  const dispatch = useDispatch();
  const location = useParams();
  var idCmd = location.id;
  var id = location.id;
  var token = localStorage.getItem("x-access-token");
  var idUser = localStorage.getItem("id_user");
  var decoded = jwt_decode(token);

  //input
  const [fileURL, setFileURL] = React.useState(null);
  const [fileName, setFileName] = React.useState(null);
  const [ext, setExt] = React.useState("");
  const [data, setData] = React.useState([]);
  const [cmd, setCmd] = React.useState({});
  const [loader, setLoader] = React.useState(true);
  const [produitExist, setProduitExist] = React.useState([]);

  /* detailCmd */
  const detailCmd = useCallback(async (idCmd, idUser) => {
    var det = await dispatch(getDetailCommandeParRef({ idCmd, idUser }));
    var dataD = await det.payload;
    setData(dataD)
    var dataCmd = await dispatch(getCommandeByIdParRef({ idCmd, idUser }));
    var cmdD = await dataCmd.payload;
    setCmd(cmdD);
    if (cmdD) setFileName(cmdD.file);
    var dataCmdH = await dispatch(historiqueCommandeParRef({ idCmd, idUser }));
    var cmdH = await dataCmdH.payload;
    setProduitExist(cmdH);
    setLoader(false);
  }, [dispatch, idCmd]);

  const getFileCmdFromDB = React.useCallback(
    async (file, file2, idUser) => {
      var fileLocal = file2;

      var splitFile = fileLocal.split(".");
      var ext1 = splitFile[splitFile.length - 1];
      setExt(ext1);
      dispatch(getFileCommandeRef({ file, idUser })).then(async (e1) => {
        setLoader(false);
        var ff = null;
        if (ext1 && ext1.toLowerCase() === "pdf") {
          ff = new Blob([e1.payload], {
            type: "application/pdf",
          });
        } else {
          ff = new Blob([e1.payload], {
            type: "application/*",
          });
        }

        const f = URL.createObjectURL(ff);
        setFileURL(f);
      });
    },
    [dispatch]
  );

  useEffect(() => {
    detailCmd(idCmd, idUser)
    if (fileName) getFileCmdFromDB(idCmd, fileName, idUser);
  }, [getFileCmdFromDB, idCmd, id, fileName]);

  const exportToExcel = async () => {
    if (data.length === 0) {
      toast.warning(t("no_data_to_export"));
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Order Details");

    // Add headers
    worksheet.columns = [
      { header: t("num_order"), key: "numero", width: 15 },
      { header: "Grossiste", key: "grossiste", width: 15 },
      { header: "Date commande", key: "date_commande", width: 15 },
      { header: "Code PCT", key: "Code_PCT", width: 15 },
      { header: "Code Article", key: "Code_article", width: 15 },
      { header: "Produit", key: "Designation_1", width: 25 },
      { header: "Quantité", key: "quantite", width: 10 },
      { header: "	Quantité rectifiée", key: "quantite_fix", width: 15 },
      { header: "Prix UN HT", key: "prix", width: 10 },
      { header: "Total HT", key: "montant", width: 10 },
    ];

    // Add rows
    data.forEach((e) => {
      worksheet.addRow({
        Code_PCT: e.produits.Code_PCT,
        numero: e.commandes.numero,
        date_commande: e.commandes.date_commande,
        grossiste: e.commandes.grossistes.Code_client,
        Code_article: e.produits.Code_article,
        Designation_1: e.produits.Designation_1,
        quantite: e.quantite,
        quantite_fix: e.quantite_fix,
        prix: e.prix ? e.prix.toFixed(3) : "0.000",
        montant: e.montant ? e.montant.toFixed(3) : "0.000",
      });
    });

    // Add styling (optional)
    worksheet.getRow(1).font = { bold: true };

    // Generate and save file
    const buffer = await workbook.xlsx.writeBuffer();
    const fileName = `Order_Details_${idCmd}.xlsx`;
    saveAs(new Blob([buffer]), fileName);

    toast.success("Exporté avec succès");
  };

  return (
    <>

      {loader ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : (
        ""
      )}
      {!loader ? (
        <Container fluid>
          <ToastContainer />
          <div className="section-image">
            <Row>
              <Col md="12">
                <Button
                  id="saveBL"
                  className="btn-wd btn-outline mr-1 float-left"
                  type="button"
                  variant="info"
                  onClick={() => {
                    window.location.replace(client+"/commandeListValider");
                  }}
                >
                  <span className="btn-label">
                    <i className="fas fa-list"></i>
                  </span>
                  {t('list')}
                </Button>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <Form action="" className="form" method="">
                  <Card>
                    <Card.Header>
                      <Card.Title as="h4">{t("order_details")}</Card.Title>
                    </Card.Header>
                    <Card.Body>
                      {obj.user.id_role != 6 && data.length > 0 && (
                        <Button
                          className="btn-wd  btn-export btn mr-1 float-right"
                          onClick={exportToExcel}
                        >
                          <span className="btn-label">
                            <i className="fas fa-file-excel"></i>
                          </span>
                          Export Excel
                        </Button>
                      )}

                      {fileName != "null" && fileName != null ? <div className="pdf-vs">
                        {ext && ext.toLowerCase() === "pdf" ? (
                          <div className="visualiser">
                            <iframe
                              title="Transition"
                              width="100%"
                              height="500px"
                              src={`${fileURL}#toolbar=0`}
                            /* src={fileURL} */
                            ></iframe>
                            <br></br>
                            <a
                              className="btn btn-info"
                              download={fileName}
                              rel="noreferrer"
                              href={Configuration.BACK_BASEURL + "commande/" + fileName}
                              target="_blank"
                            >
                              <i className="fas fa-download"></i> {t("download")}
                            </a>
                          </div>
                        ) : (
                          <div className="visualiser">
                            {/* <img
                              src={fileURL}
                              className="img-file"
                              alt=""
                            ></img> */}
                            <br></br>
                            <a
                              download={fileName}
                              rel="noreferrer"
                              href={Configuration.BACK_BASEURL + "commande/" + fileName}
                              target="_blank"
                              className="btn btn-info"
                            >
                              <i className="fas fa-download"></i> {t("download")}
                            </a>
                          </div>
                        )}

                      </div> : null}

                      <div>

                        {/* <ImprimerCmd t={t} idCmd={idCmd} type={2} /> */}

                        <br></br>
                        <table className="table table-bordered">
                          <thead>
                            <tr className="table-info">
                              <th>{t("num_order")}</th>
                              <th>Code Grossiste</th>
                              <th>Grossiste</th>
                              <th>Date {t("commande")}</th>
                              <th>{cmd.etat != 2 ?t("date_liv_souhaite"):t("date_liv")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {cmd ? <tr>
                              <td>{cmd.numero}</td>
                              <td>{cmd.grossistes ? cmd.grossistes.Code_client : " "}</td>
                              <td>{cmd.grossistes ? cmd.grossistes.Raison_sociale : " "}</td>
                              <td>{cmd.date_commande}</td>
                              <td>{cmd.etat == 2 ? cmd.date_livraison_afc : cmd.date_livraison}</td>
                            </tr> : <tr><td colSpan={"5"} style={{ textAlign: "center" }}>Aucuns Details</td></tr>}

                          </tbody>
                        </table>
                        <hr></hr>
                        {cmd ? <h4><strong>{t('montant_total')}: {new Intl.NumberFormat('fr-FR', {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3
                        }).format(cmd.Montant)} HT TND</strong></h4> : null}
                        <table className="table table-bordered">
                          <thead>
                            <tr className="table-info">
                              <th>{t("code_pct")}</th>
                              <th>{t("code_article")}</th>
                              <th>{t("product")}</th>
                              <th>{t("qte")}</th>
                              <th style={{ backgroundColor: "#c20d20", fontWeight: "bold", color: "#fff" }}>{t("quantite_rectif")}</th>
                              <th>{t("prix")} HT</th>
                              <th>{t("total")} </th>
                            </tr>
                          </thead>
                          <tbody>
                            {data.length > 0 ? data.map((e) => {
                              return (
                                <tr key={"ligne-" + e.id} className={e.commerce == 0 ? "no-commerce" : null} style={{ backgroundColor: e.quantite != e.quantite_fix ? "#ffc10736" : "transparent" }}>
                                  <td >{e.produits.Code_PCT}</td>
                                  <td>{e.produits.Code_article}</td>
                                  <td>{e.produits.Designation_1}</td>
                                  <td>{e.quantite}</td>
                                  <td style={{ backgroundColor: "#c20d20", fontWeight: "bold", color: "#fff" }}>{e.quantite_fix}</td>
                                  <td>{e.prix ? new Intl.NumberFormat('fr-FR', {
                                    minimumFractionDigits: 3,
                                    maximumFractionDigits: 3
                                  }).format(e.prix) : "0.000"}</td>
                                  <td>{e.montant ? new Intl.NumberFormat('fr-FR', {
                                    minimumFractionDigits: 3,
                                    maximumFractionDigits: 3
                                  }).format(e.montant) : "0.000"}</td>
                                </tr>
                              );
                            }) : <tr>
                              <td colSpan={"7"} style={{ textAlign: "center" }}>Aucuns details</td>
                            </tr>}
                          </tbody>
                        </table>
                      </div>
                      <div className="clearfix"></div>
                      <hr></hr>
                      {(obj.user.id_role == 5 || obj.user.id_role == 4 || obj.user.id_role == 3) && produitExist.length > 0 ?
                        <> <Col md="12">
                          <Card.Header>
                            <Card.Title as="h4">Liste des produits annulés</Card.Title>
                          </Card.Header>
                        </Col>
                          <br></br>
                          <Col md="12">
                            <table className="table tableinconnue">
                              <thead style={{ backgroundColor: produitExist.length > 0 ? 'red' : 'transparent', color: "#fff" }}>
                                <tr>
                                  <th style={{ color: "#fff !important" }}>Code</th>
                                  <th style={{ color: "#fff !important" }}>Designation</th>
                                  <th style={{ color: "#fff !important" }}>Quantité</th>
                                </tr>
                              </thead>
                              <tbody>
                                {produitExist.map((item, index) => (
                                  <tr key={index}>
                                    <td>{item.code}</td>
                                    <td>{item.designation}</td>
                                    <td>{item.quantite}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </Col>

                        </>
                        : null}
                    </Card.Body>
                  </Card>
                </Form>
              </Col>
            </Row>
          </div>
        </Container>
      ) : (
        ""
      )}
    </>
  );
}

export default DetailsCmd;
